

const TayTalk = () => {
  const posts = [
    {
      title: "No One’s Coming to Save You",
      summary: "A reflection on the profession’s habit of waiting for organizations and institutions to fix our conditions, and an invitation for social workers to reclaim their own power, identity, and responsibility for shaping the future of the field.",
      link: "https://www.linkedin.com/pulse/ones-coming-save-you-patrick-taylor-lcsw-gnkhc",
      // img: IMG_POST1
    },
    {
      title: "A Vision for All of Us",
      summary: "A response to NASW’s Blueprint of Public Policy Priorities that celebrates its bold, macro scope while calling out how its concrete priorities overwhelmingly center clinical roles—and what that means for macro social workers who remain unseen and unsupported.",
      link: "https://www.linkedin.com/pulse/vision-all-us-patrick-taylor-lcsw-ws0ac",
      // img: IMG_POST2
    },
    {
      title: "Social Work, We Need to Talk: An Intervention",
      summary: "A candid, compassionate “intervention” with the profession itself, naming the gap between what social work says it is and what it actually prioritizes, and calling for a return to a more honest, whole, system-conscious version of who we can be.",
      link: "https://www.linkedin.com/pulse/social-work-we-need-talk-intervention-patrick-taylor-lcsw-pijcc",
      // img: IMG_POST3
    }
  ];

  return (
    <section name="tay-talk" className="bg-white  font-montserrat px-5 py-6 lg:py-10 md:px-24">
      <h1 className="text-2xl lg:text-3xl font-semibold text-center text-black mb-2 lg:mb-4">Tay Talk</h1>
      <p className="text-center text-sm lg:text-base text-dark-gray font-medium mb-4 lg:mb-6 max-w-4xl mx-auto">
        Tay Talk is a collection of reflective pieces from the founder that lean into honesty,
        curiosity, and a willingness to poke at the parts of social work we often leave unexamined.
        These essays explore the profession from different angles, sometimes challenging, sometimes affirming,
        always pushing for a clearer, more grounded understanding of who we are and what we’re doing.
      </p>

      <div className="grid md:grid-cols-3 gap-4 lg:gap-8">
        {posts.map((post, index) => (
          <div key={index} className="bg-light-gray rounded-lg shadow-sm lg:shadow-md p-6 flex flex-col justify-between hover:shadow-xl transition-shadow duration-300">
            {/* Optional image if available */}
            {/* <img src={post.img} alt={post.title} className="w-full h-32 object-cover rounded-md mb-4" /> */}

            <h2 className="text-lg md:text-xl font-semibold text-black mb-1 lg:mb-2">{post.title}</h2>
            <p className="text-dark-gray text-sm lg:text-base font-medium mb-2 lg:mb-4">{post.summary}</p>
            <a
              href={post.link}
              target="_blank"
              rel="noopener noreferrer"
              className="text-white text-sm lg:text-base bg-primary py-2 px-4 rounded-md font-semibold text-center hover:bg-primary/80 transition-colors duration-300"
            >
              Read More
            </a>
          </div>
        ))}
      </div>

      <div className="mt-4 lg:mt-8 flex justify-center">
        <a
          href="https://www.linkedin.com/in/taylor-macrovision/"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-light-olive text-dark-gray text-sm lg:text-base font-semibold py-3 px-10 rounded-md shadow-md hover:bg-light-olive/80 transition-colors duration-300"
        >
          Read more Tay Talks on LinkedIn
        </a>
      </div>
    </section>
  );
};

export default TayTalk;
